import { render } from "./VisitDetailsHosPal.vue?vue&type=template&id=98dbcb5e"
import script from "./VisitDetailsHosPal.ts?vue&type=script&lang=js&external"
export * from "./VisitDetailsHosPal.ts?vue&type=script&lang=js&external"

import "../VisitDetailsHomeCare/VisitDetailsHomeCare.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__